import React, { useEffect, useState } from 'react'
import { useEventListener } from '../../hooks'
import { getAtomicAsset } from '../helpers/Api'
import { MarketInfoDetails } from '../marketinfo/MarketInfoDetails'
import MarketPreviewDetailsTable from './MarketPreviewDetailsTable'
import { AssetPreviewImage } from './AssetPreviewImage'

export const MarketAssetPreviewInfo = ({
    cancel,
    asset,
    listing,
    newOwner,
    currentAsset,
    buttons,
}) => {
    const [atomicData, setAtomicData] = useState(null)

    let { assetId, contract, buyer } = asset

    const getAtomicData = () => {
        const controller = new AbortController()
        if (contract === 'atomicassets')
            getAtomicAsset(assetId)
                .then((res) => {
                    res && res.success && setAtomicData(res.data)
                })
                .catch((e) => {
                    console.error(e)
                })
        return () => controller.abort()
    }

    const keyHandler = ({ key }) => {
        const ESCAPE_KEYS = ['27', 'Escape']
        if (ESCAPE_KEYS.includes(String(key))) {
            cancel()
        }
    }

    useEventListener('keydown', keyHandler)

    useEffect(() => {
        if (!atomicData) {
            getAtomicData()
        }
    }, [assetId])

    return (
        <div className="grid w-full grid-cols-3 bg-zinc-300 dark:!bg-paperd">
            <div className="w-full h-full col-span-3 md:col-span-1 md:relative md:flex md:justify-center md:item-center dark:bg-zinc-950 bg-zinc-200 md:h-full">
                <AssetPreviewImage asset={asset} />
            </div>

            <div className="col-span-3 pl-4 md:col-span-2 dark:bg-zinc-900 bg-zinc-100">
                <div className="w-full mt-5 text-left">
                    <MarketPreviewDetailsTable
                        asset={asset}
                        newOwner={newOwner}
                        currentAsset={currentAsset}
                        atomicData={atomicData}
                        showData={false}
                        className="none"
                    />
                    <MarketInfoDetails
                        asset={asset}
                        currentAsset={currentAsset}
                        listing={listing}
                        cancel={cancel}
                        className="none"
                    />
                    {!buyer ? (
                        <div className="h-32 mx-5 mb-4">{buttons}</div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </div>
    )
}
